import { connect } from 'react-redux';
import BreakDownTile from './BreakDownTile';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';
import { setMosaicTerm } from '../../../../common/loan/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    loanTerm: state.loan.loanTerm,
    obsDownPayment: state.obs.obsDownPayment,
    capDownPayment: state.cap.capDownPayment,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    loanProvider: state.loan.loanProvider,
    mosaicDownPayment: state.loan.mosaicDownPayment,
    mosaicTerm: state.loan.mosaicTerm,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    formattedSystemPrice: state.solar.systemSize,
    provider: state.utility.provider,
    energyValue: state.utility.energyValue,
    annualInflation: state.utility.annualInflation,
    setSelectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    sgipToggle: state.sgip.sgipToggle,
    includeESS: state.ess.includeESS,
    essPrice: state.ess.essPrice,
    capTerm: state.cap.capTerm,
    obsTerm: state.obs.obsTerm,
    resiToggle: state.tax.resiToggle,
    isLocked: state.isLockedUI.isLocked,
    setMosaicTerm,
});

const combinedActions = {
    setSelectedFinancing,
    setMosaicTerm,
};

export default connect(mapStateToProps, combinedActions)(BreakDownTile);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/BreakDownTile/index.js